import * as Yup from "yup";

export default Yup.object().shape({
    description: Yup.string(),
});